import React, { useEffect, useState } from "react";
import "../../../../style/alerts.scss";
import { useTranslation } from "react-i18next";
import HtmlTooltip from "@mui/material/Tooltip";
interface IProps {
  assigned: boolean;
  startTime: number;
  saleFrom: number;
  status: string;
  waitList: boolean;
}

const SingleAlertsExercise: React.FC<IProps> = ({ assigned, startTime, saleFrom, status, waitList }) => {
  const { t } = useTranslation();
  const [past, setPast] = useState<boolean>(true);
  const [future, setFuture] = useState<boolean>(true);

  useEffect(() => {
    const date = new Date();
    const startTimeDate = new Date(startTime);
    const saleFromDate = new Date(startTime);
    if (date > startTimeDate) {
      setPast(false);
    }
    if (date < saleFromDate) {
      setFuture(false);
    }
  }, []);

  return (
    <React.Fragment>
      {(assigned && waitList === false) && <b className="alert-center alert alert-green alert-small ">{t("jestes_zapisany")}</b>}





      <HtmlTooltip
        placement="bottom-start"
        title={
          <React.Fragment>
            <article
              className="tooltip-description"
              dangerouslySetInnerHTML={{ __html: "Zapisanie się na listę rezerwową spowoduje, że zapiszemy Cie do kolejki osób oczekujących na rezerwacje. Jeśli ktoś zrezygnuje, to zapiszemy Ciebie." }}
            ></article>
          </React.Fragment>
        }
      >
        <div>{waitList === true && <b className="alert-center alert alert-yellow alert-small ">Lista rezerwowa</b>}</div>
      </HtmlTooltip>


      {/* 
      {!past && status === 'G' && <b className="alert alert-red alert-small alert-center">Zajęcie się odbyło</b>} */}
      {!future && status === "G" && (
        <b className="alert alert-yellow alert-small alert-center">{t("sprzedaz_nieaktywna")}</b>
      )}

      {/* <b *ngIf="exerciseStatus === 'G' && past === true" class="alert-negative"
        >Te zajęcia już minęły
      </b>
      <b *ngIf="exerciseStatus === 'G' && past === false" class="alert-negative"
        >Sprzedaż nieaktywna
      </b> */}
    </React.Fragment>
  );
};

export default SingleAlertsExercise;
